export interface WirelessCommunicationProducts {
  id: string;
  name: string;
  tagline: string;
  subtitle: string;
  description: string;
  images: string[]; // Array for carousel
  document: string;
  features: string[];
  specs: Record<string, string>;
  highlights: { title: string; value: string; icon: string }[];
}

export const wirelessCommunicationProducts: WirelessCommunicationProducts[] = [
  {
    id: "cd665",
    name: "CWD CD665",
    subtitle: "Portable Radio",
    tagline: "Empower Your Operation with CD665 Series",
    description:
      "Compact, lightweight, and powerful - the CD665 Series delivers crystal-clear audio, extended coverage, long battery life, and exceptional durability for customer-facing teams.",
    images: ["/images/products/wireless-communication/cd665-front.png"],
    document: "/documents/wireless-communication/cwd-cd665.pdf",
    features: [
      "Slim & Lightweight (280g)",
      "Over 20 Hours Battery Life",
      "IP67 & MIL-STD-810G Certified",
      "AI Noise Cancellation (30dB)",
      "Built-in Bluetooth 5.0 & GPS",
    ],
    highlights: [
      {
        title: "Rugged",
        value: "IP67 & MIL-STD-810G",
        icon: "ion:shield-checkmark-outline",
      },
      {
        title: "Audio",
        value: "AI Noise Cancel",
        icon: "ion:volume-high-outline",
      },
      {
        title: "Compact",
        value: "Lightweight Design",
        icon: "ion:phone-portrait-outline",
      },
    ],
    specs: {
      "Frequency Range": "UHF: 400-527MHz, VHF: 136-174MHz",
      "Channel Capacity": "1024",
      Dimensions: "122 x 55 x 31.5mm",
      Weight: "280g (with antenna & battery)",
      Display: "1.8 inch Color (160x128)",
      Battery: "2000 mAh Li-polymer",
    },
  },
  {
    id: "cd765",
    name: "CWD CD765",
    subtitle: "Portable Radio",
    tagline: "A Future-Ready Digital Radio Redefining Communication",
    description:
      "Designed for the future, the CD765 features powerful audio, long battery life, exceptional portability, and rugged durability. It sets a new benchmark in digital communication.",
    images: ["/images/products/wireless-communication/cd765-front.png"],
    document: "/documents/wireless-communication/cwd-cd765.pdf",
    features: [
      "Slim Design (29.5mm thick, 310g)",
      "24-Hour Battery Life (Li-polymer)",
      "IP68 Waterproof (2m for 4 hours)",
      "2.4-inch color display",
      "AI-based noise cancellation",
    ],
    highlights: [
      {
        title: "Portability",
        value: "Slim 29.5mm body",
        icon: "ion:resize-outline",
      },
      {
        title: "Durability",
        value: "IP68 & MIL-STD-810G",
        icon: "ion:shield-checkmark-outline",
      },
      {
        title: "Longevity",
        value: "24h Battery Life",
        icon: "ion:battery-charging-outline",
      },
    ],
    specs: {
      "Frequency Range": "UHF: 350-470MHz, VHF: 136-174MHz",
      "Channel Capacity": "1024",
      Dimensions: "132 x 55 x 29.5mm",
      Weight: "310g (Radio only)",
      Display: "2.4 inch Color LCD",
      Battery: "2400 mAh Li-polymer",
    },
  },
  {
    id: "cd775",
    name: "CWD CD775",
    subtitle: "Mobile Radio",
    tagline: "Empower Your Operation",
    description:
      "A flexible digital mobile radio designed for smooth communication across vehicles, motorcycles, and control rooms. Features AI noise cancellation and multiple control head options.",
    images: ["/images/products/wireless-communication/cd775-main.png"],
    document: "/documents/wireless-communication/cwd-cd775.pdf",
    features: [
      "AI-Based Noise Cancellation (30dB reduction)",
      "Flexible Installation (Desktop/Vehicle)",
      "Built-in Bluetooth 5.0 & GPS",
      "IP54 Dust & Water Protection",
      "Large 2.4-inch display",
    ],
    highlights: [
      {
        title: "Clear Audio",
        value: "AI Noise Cancel",
        icon: "ion:volume-high-outline",
      },
      {
        title: "Flexible",
        value: "Remote Head Options",
        icon: "ion:car-sport-outline",
      },
      {
        title: "Connected",
        value: "BT 5.0 & GPS",
        icon: "ion:bluetooth-outline",
      },
    ],
    specs: {
      "Frequency Range": "UHF: 350-470MHz, VHF: 136-174MHz",
      "Channel Capacity": "1024",
      Dimensions: "61.5 x 177 x 179 mm",
      Weight: "1520g",
      "Power Output": "UHF: 1-45W, VHF: 5-50W",
      "IP Rating": "IP54",
    },
  },
  {
    id: "cd885",
    name: "CWD CD885",
    subtitle: "Digital Repeater",
    tagline: "Enhance Your Operation with Seamless Coverage",
    description:
      "A next-generation digital repeater ensuring seamless voice and data communication. Features integrated router/SIP gateway, AC/DC auto-switch, and high-performance network reliability.",
    images: ["/images/products/wireless-communication/cd885-main.png"],
    document: "/documents/wireless-communication/cwd-cd885.pdf",
    features: [
      "Mixed Analog & Digital Auto Switch",
      "Integrated Router & SIP Gateway",
      "AC/DC Auto Switch Power",
      "Web-based Backend Management",
      "SNMP v3 Security Technology",
    ],
    highlights: [
      {
        title: "Coverage",
        value: "Wide Range & Power",
        icon: "ion:wifi-outline",
      },
      {
        title: "Smart",
        value: "Integrated Router/SIP",
        icon: "ion:layers-outline",
      },
      {
        title: "Reliable",
        value: "AC/DC Auto Switch",
        icon: "ion:power-outline",
      },
    ],
    specs: {
      "Frequency Range": "UHF: 400-470MHz, VHF: 136-174MHz",
      "Channel Capacity": "64",
      Dimensions: "44 x 483 x 366 mm",
      Weight: "5.8kg",
      "Power Output": "5-50W (adjustable)",
      "Operating Voltage": "DC: 13.6V, AC: 100-240V",
    },
  },
];
